import React from "react";
import { LinePath } from "@visx/shape";
import { Group } from "@visx/group";
import {AxisLeft, AxisBottom, AxisRight} from "@visx/axis";
import { LineChartProps } from "./interfaces";
import { DataPriceProps, DataValueProps } from "interfaces/DataProps";
import {
  AXIS_COLOR,
  AXIS_BOTTOM_TICK_LABEL_PROPS,
  AXIS_LEFT_TICK_LABEL_PROPS,
  AXIS_RIGHT_TICK_LABEL_PROPS,
} from "./constants";
import "./index.css";

const LineChart: React.FC<LineChartProps> = ({
  data,
  data_secondary,
  width,
  yMax,
  margin,
  xScale,
  yScale,
  yScale_secondary,
  hideBottomAxis = false,
  hideLeftAxis = false,
  hideRightAxis = false,
  stroke,
  stroke_secondary,
  top,
  left,
  xTickFormat,
  xTickFormat_secondary,
  children,
}) => {
  if (!data && !data_secondary) return null;
  // accessors


  const getDate = (d: DataPriceProps | DataValueProps) => new Date(d.date);
  const getPrice = (d: DataPriceProps) => d?.price;
  const getValue = (d: DataValueProps) => d?.value;

  if (width < 10) return null;

  const xMax = width - margin.left - margin.right;

  // https://airbnb.io/visx/docs/axis

  return (
    <Group left={left || margin.left} top={top || margin.top}>
      <LinePath<DataPriceProps>
        data={data}
        x={(d) => xScale(getDate(d) as any) || 0}
        y={(d) => yScale(getPrice(d) as any) || 0}
        strokeWidth={1.5}
        stroke={stroke}
      />
      <LinePath<DataValueProps>
          data={data_secondary}
          x={(d) => xScale(getDate(d) as any) || 0}
          y={(d) => yScale_secondary(getValue(d) as any) || 0}
          strokeWidth={1.5}
          stroke={stroke_secondary}
      />
      {!hideBottomAxis && (
        <AxisBottom
          top={yMax + margin.top}
          scale={xScale}
          numTicks={width > 520 ? 10 : 5}
          stroke={AXIS_COLOR}
          tickStroke={AXIS_COLOR}
          tickLabelProps={() => AXIS_BOTTOM_TICK_LABEL_PROPS}
        />
      )}
      {!hideLeftAxis && (
        <AxisLeft
          label={'Close Price ($)'}
          labelClassName="axisLeftLabel"
          scale={yScale}
          numTicks={5}
          stroke={AXIS_COLOR}
          tickStroke={AXIS_COLOR}
          tickLabelProps={() => AXIS_LEFT_TICK_LABEL_PROPS}
          tickFormat={(d) => {
            return xTickFormat ? xTickFormat(d) : d;
          }}
        />
      )}
      {!hideRightAxis && (
          <AxisRight
              label={'CPI Index'}
              scale={yScale_secondary}
              numTicks={5}
              top={0}
              left={xMax}
              stroke={AXIS_COLOR}
              tickStroke={AXIS_COLOR}
              tickLabelProps={() => AXIS_RIGHT_TICK_LABEL_PROPS}
              tickFormat={(d) => {
                return xTickFormat_secondary ? xTickFormat_secondary(d) : d;
              }}
          />
      )}
      {children}
    </Group>
  );
};

export default LineChart;
